import { environment } from "environments/environment";

export class Api {
  /* public static base = 'https://vendorinfra.com/vendor-web/';
          public static base2 = 'https://vendorinfra.com:8443/vendor_images/'; */

  //  public static base = 'https://customer.vendorinfra.com/vendor-web/';
  // public static base2 = 'https://customer.vendorinfra.com/vendor_images/';

  //  public static base = 'https://admin.vendorinfra.com/vendor-web/';

  // public static base = 'https://admin.vendorinfra.com/vendor-web-qa/';

  // ---------------------------Qa URL-------------------------------------
  public static base = environment.baseUrl+"vendor-web/";
  public static base2 = environment.baseUrl+"vendor_images/";
  public static HELP_SERIVCE = environment.baseUrl+"vendor_images/Rates.pdf";
  // ----------------------------------------------------------------------

  // ---------------------Production URL------------------------------------
  // public static base = 'https://admin.vendorinfra.com/vendor-web/';
  // public static base2 = 'https://admin.vendorinfra.com/vendor_images/';
  // public static Help = 'https://admin.vendorinfra.com/vendor_images/Rates.pdf';
  // -----------------------------------------------------------------------

  //  --------------------- AWS URL -----------------------------------------
  //  public static base = 'http://65.0.178.20:8080/vendor-web/';
  //  public static base2 = 'http://65.0.178.20:8080/vendor_images/';
  //  public static HELP_SERIVCE = "http://65.0.178.20:8080/vendor_images/Rates.pdf";
  //  -----------------------------------------------------------------------

  public static HOW_TO_USE_COMPANY = Api.base2 + "companyHowToUse.pdf";
  public static HOW_TO_USE_VENDOR = Api.base2 + "vendorHowToUse.pdf";
  public static HOW_TO_USE_BOTH = Api.base2 + "bothHowToUse.pdf";
  public static HOW_TO_USE_PDF = Api.base2 + "How_To_use.pdf";

  public static RATES_DOCUMENTS = Api.base2 + "16-HowtoexploreSORRates.pdf";
  public static SECTOR_INTELLIGENCE =
    Api.base2 + "13-Howtoexploresectorintelligence.pdf";
  public static HOW_TO_MANAGE_COMPANY_PROFILE =
    Api.base2 + "1-HowtoManageCompanyProfilee.pdf";
  public static HOW_TO_MANAGE_VENDOR_PROFILE =
    Api.base2 + "1-HowtoManageVendorProfile.pdf";
  public static SUPPORT_REQUEST =
    Api.base2 + "5-HowcanItakehelpfromsupport.pdf";
  public static HOW_TO_ADD_PROJECT = Api.base2 + "6-Howtoaddprojects.pdf";
  public static HOW_TO_ADD_PLANT_AND_EQUIPMENT =
    Api.base2 + "7-Howtoaddplantandequipment.pdf";
  public static HOW_TO_ADD_TEAM_MEMBER =
    Api.base2 + "14-HowcanIaddteammember.pdf";

  /*
    public static HOW_TO_EDIT_PROFILE =    Api.base2 + '2-How_to_edit_profile.pdf';
    public static HOW_DO_I_RESPONSE_TO_SUPPORT_MAIL =    Api.base2 + '6-How_do_I_response_to_support_mail.pdf';
    public static HOW_TO_ADD_PROJECT =    Api.base2 + '6-How_to_add_project.pdf';
    public static HOW_TO_ADD_PLANT_AND_EQUIPMENT =    Api.base2 + '7-How_to_add_plant_and_equipment.pdf';
    public static HOW_TO_ADD_TEAM_MEMBER =    Api.base2 + '14-How_can_I_add_team_member.pdf';
     */
  public static LOGIN = Api.base + "usersLogin";

  public static UPDATEUSERSPASSWORD = Api.base + "updateUsersPassword";

  public static SAVECHANGEPASSWORDREQUEST =
    Api.base + "sendChangePasswordRequest";

  public static GETACTIVECOUNTRYDETAILS = Api.base + "getActiveCountryDetails";

  public static CURRENT_STATUS_LIST = Api.base + 'getListOfCurrentStatusDetails';

  public static GET_PROJECT_VALUE_LIST = Api.base + 'getListOfProjectValueDetails';
  
  public static GET_TENDERING_AUTHORITY_LIST = Api.base + 'getListOfTenderingAuthorityDetails';
  
  public static SAVEUSERSDETAIL = Api.base + "saveUsersDetail";

  public static SAVETEAMMEMBERSDETAIL = Api.base + "saveTeamMembersDetail";

  public static UPDATETEAMMEMBERSDETAIL = Api.base + "updateTeamMembers";

  public static RESENDUSEROTP = Api.base + "resendUserOtp";

  public static OTPVERIFICATION = Api.base + "otpVerification";

  public static GETACTIVESUBSCRIPTIONDETAILS =
    Api.base + "getActiveSubscriptionDetails";

  public static GETACTIVESUBSCRIPTIONLIST =
    Api.base + "getActiveSubscriptionDetailsByType";

  public static GETACTIVEPROJECTSDETAILS = Api.base + "getActiveProjectDetails";

  public static GETACTIVESTATUSDETAILS = Api.base + "getActiveStatusDetails";

  public static PAYMENTINITIATE = Api.base + "paymentInitiate";

  public static GETACTIVESTATEDETAILSBYCOUNTRYID =
    Api.base + "getActiveStateDetailsByCountryId";

  public static GETACTIVETEAMMEMBERSDETAILS =
    Api.base + "getActiveTeamMembersDetails";

  public static GETACTIVETEAMMEMBERSDETAILSCOMPANYID =
    Api.base + "getActiveTeamMembersDetailsCompanyId";

  public static GETEQUIPMENTBYEQUIPMENTID =
    Api.base + "getEquipmentByEquipmentId";

  public static GETACTIVERATEDETAILSBYSTATEID =
    Api.base + "getActiveRateDetailsByStateId";

  public static GETSECTORDETAILSBYCOMPANYID =
    Api.base + "getSectorDetailsByCompanyId";

  public static SAVEEQUIPMENTNOTIFICATIONDETAIL =
    Api.base + "saveEquipmentNotificationDetail";

  public static GETACTIVEFORLDERDETAILSBYTYPE =
    Api.base + "getActiveFolderDetailsByType";

  public static GETVENDORFORWORKTYPEBYPROJECTORVENDOR =
    Api.base + "getVendorForWorkTypeByProjectOrVendor";

  public static GET_DOCUMENTS_LIST = Api.base + "getActiveDocumentDetails";

  public static GET_PROJECT_DETAILS = Api.base + "getProjectDetails";
  public static getActiveProjectDetailsByProjectIdOptimiseAPIForCustomerAndAdmin = Api.base + "getActiveProjectDetailsByProjectIdOptimiseAPIForCustomerAndAdmin";
  // public static GET_PROJECT_DETAILS = Api.base + 'getActiveProjectDetailsByProjectIdForMobileTeam';

  public static GET_COMPANY_DETAILS = Api.base + "saveCompanyVisitDetail";

  public static SENDMAILREMINDER = Api.base + "sendMailReminder";

  public static GETALL_VENDORS = Api.base + "getActiveVendorDetails";
  // public static GETACTIVE_VENDORS_DETAILS_FOR_UNBLOCK_VENDOR_LIST =
  //   Api.base + "getActiveVendorDetailsForUnblockVendorList";

  public static GETACTIVE_VENDORS_DETAILS_FOR_UNBLOCK_VENDOR_LIST_FOR_MOBILE =
    Api.base + "getActiveVendorDetailsForUnblockVendorListForMobile";

  public static SAVE_DOC = Api.base + "saveDocumentDetail";

  public static SEARCHPROJECTFORCOMPANY = Api.base + "searchProjectForCompany";
  
  public static GETACTIVEPROJECTLISTBYCOMPANYID = Api.base + "getActiveProjectListOptimisedByCompanyId";

  public static GETINQUIRYDETAILSBYDATESANDUSERNAME =
    Api.base + "getInquiryDetailsByDatesAndUserName";

  public static GETEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAME =
    Api.base + "getEquipmentByCategorySubCategoryZoneTypeName";

  public static GETSHORTLISTEDEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAMEBYCOMPANY =
    Api.base +
    "getShortlistedEquipmentByCategorySubCategoryZoneTypeNameByCompany";

  public static GETEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAMEBYCOMPANY =
    Api.base + "equipmentSearchForMyEquipment";
  // public static GETEQUIPMENTBYCATEGORYSUBCATEGORYZONETYPENAMEBYCOMPANY = Api.base + 'getEquipmentByCategorySubCategoryZoneTypeNameByCompany';

  public static GETACTIVEEQUIPMENTSUBCATEGORYDETAILSBYEQUIPMENTCATEGORY =
    Api.base + "getActiveEquipmentSubCategoryDetailsByEquipmentCategory";

  public static GETACTIVEPROJECTTYPEDETAILS =
    Api.base + "getActiveProjectTypeDetails";

  public static GET_STATUS_VENDOR = Api.base + "getActiveStatusDetails";

  public static GETACTIVECOMPANYSIZEDETAILS =
    Api.base + "getActiveCompanySizeDetails";

  public static GETACTIVESECTORDETAILS = Api.base + "getActiveSectorDetails";

  // public static GETSECTORSDETAILSBYCOMPANYID = Api.base + 'getSectorDetailsByCompanyId';

  public static GETACTIVEWORKTYPEDETAILSBYSECTOR =
    Api.base + "getActiveWorkTypeDetailsBySector";

    public static GETACTIVESUBSECTORDETAILSBYSECTOR = Api.base + 'getActiveModeDetails';
    
  public static GETACTIVESECTORINTELLIGENCEDETAILSBYSECTTOR =
    Api.base + "getActiveSectorIntelligenceDetailsBySector";

  public static GETACTIVEPROJECTSSTAGEDETAILS =
    Api.base + "getActiveProjectStageDetails";

  public static GETACTIVEWORKTYPEDETAILS =
    Api.base + "getActiveWorkTypeDetails";

  public static SEARCHREQUESTPROPOSAL = Api.base + "searchRequestProposal";

  public static SAVEINQUIRYDETAIL = Api.base + "saveInquiryDetail";

  public static SAVEINQUIRYDETAILDOMAIN = Api.base + "saveInquiryDomainDetail";

  public static SEARCHVENDOR = Api.base + "searchVendor";

  public static SEARCHPROJECT = Api.base + "searchProject";
  public static SEARCH_PROJECT_FOR_COMPANY =
    Api.base + "searchProjectForCompany";

  public static GETVENDORDETAILSBYWORKTYPELOCATIONCOUNTRYPROJECTSIZE =
    Api.base + "getVendorDetailsByWorkTypeLocationCountryProjectSize";

  public static GETPROJECTBYWORKTYPELOCATIONCOUNTRYPROJECTSIZE =
    Api.base + "getProjectBYWorkTypeLocationCountryProjectSize";

  public static SAVEREQUESTPROPOSALDETAIL =
    Api.base + "saveRequestProposalDetail";

  public static SAVEPROJECTDETAIL = Api.base + "saveProjectDetail";

  public static UPDATEPROJECT = Api.base + "updateProject";

  public static DELETEPROJECT = Api.base + "deleteProject";

  public static DELETETEAMMEMBERS = Api.base + "deleteTeamMembers";

  public static GETACTIVESTATEDETAILS = Api.base + "getActiveStateDetails";

  public static getListOfVendorProjectRecommendation = Api.base + "getListOfVendorProjectRecommendation";
  
  public static GETACTIVEANNUALTURNOVERDETAILS =
    Api.base + "getActiveAnnualTurnoverDetails";

  public static GETVENDORDASHBOARDDETAILS =
    Api.base + "getVendorDashboardDetails";
    
    public static GETVENDORDASHBOARDCOUNT =
      Api.base + "vendorDashBoardDetails";

  public static GETACTIVEVENDORDETAILSBYUSERIDMAIN =
    Api.base + "getActiveVendorDetailsByUserId";

    public static GETACTIVE_TENDER_DETAILS =
      Api.base + "getActiveTenderDetails";

      public static SEARCHTENDER = Api.base + "searchTender";

  public static GETPROJECTPROPOSALDETAILSBYVENDORID =
    Api.base + "getProjectProposalDetailsByVendorId";

  public static GETACTIVEVENDORDETAILSBYUSERIDFOREDIT =
    Api.base + "getActiveVendorDetailsByUserId";

  public static GETACTIVEVENDORDETAILSBYUSERID =
    Api.base + "getActiveVendorTempDetailsByUserId";

  public static GETACTIVECOMPANYDETAILS = Api.base + "getActiveCompanyDetails";

  public static GET_COMPANY_DETAIL = Api.base + 'getActiveCompanyDetailsByUserId';

  public static GET_ALL_COMPANY_NAME = Api.base + "getCompany";

  public static ACTIVE_PROJECT_STAGE =
    Api.base + "getActiveProjectStageDetails";

    public static UPDATE_EQUIPMENT_REQUIREMENTS =
      Api.base + "updateEquipmentRequirementPosting";

      public static Update_Vendor_ForWorkType =
      Api.base + "updateVendorForWorkType";

      public static GETEQUIPMENTREQUIREMENTPOSTINGDETAILSBYEQUIPMENTID =
      Api.base + "getActiveEquipmentRequirementPostingDetailByEquipmentId";

  public static GET_ACTIVE_DOCUMENT_DETAIL_BY_PARENT_ID =
    Api.base + "getActiveDocumentDetailsByParentId";

  public static GETACTIVELOCATIONDETAILS =
    Api.base + "getActiveLocationDetails";

  public static GETACTIVECOMPANYTYPEDETAILS =
    Api.base + "getActiveCompanyTypeDetails";

  public static HOME_PAGE_DOCUMENT_REPO_SEARCH = Api.base + "searchFolder";

  public static GETACTIVESTATEDETAILBYCOUNTRYID =
    Api.base + "getActiveStateDetailsByCountryId";

  public static GETWORKTYPEBYPROJECTID = Api.base + "getWorkTypeByProjectId";

  public static SAVEVENDORDETAIL = Api.base + "saveVendorDetail";
  public static SAVEVENDORVISITDETAIL = Api.base + "saveVendorVisitDetail";
  public static SAVECOMPANYDETAIL = Api.base + "saveCompanyDetail";

  // public static UPDATECOMPANY = Api.base + 'updateCompany';
  public static UPDATECOMPANY = Api.base + "updateCompanyTemp";

  public static DELETEEQUIPMENT = Api.base + "deleteEquipment";

  public static DELETEEQUIPMENTSHORTLISTED =
    Api.base + "deleteEquipmentShortlisted";
  
  public static DELETEEQUIPMENTREQUIRMENT = Api.base + "deleteEquipmentRequirementPosting";

  // public static UPDATEVENDOR = Api.base + 'updateVendor';
  public static UPDATEVENDOR = Api.base + "updateVendorTemp";

  public static UPDATE_VENDOR_FROM_MAIL = Api.base + "updateVendorForWorkType";

  public static GET_EQUIPMENT_CONTACT_DETAIL =
    Api.base + "getEquipmentContactDetails";

  public static UPDATECOMPANYWITHEQUIPMENT =
    Api.base + "updateCompanyWithEquipment";

  public static GETACTIVECOMPANYDETAILSBYUSERID =
    Api.base + "getActiveCompanyDetailsByUserId";

  public static GETACTIVECOMPANYTEMPDETAILSBYUSERID =
    Api.base + "getActiveCompanyTempDetailsByUserId";

  // public static GETEQUIPMENTSHORTLISTEDBYCOMPANYID =
  //   Api.base + "getEquipmentShortlistedByCompanyId";
    
    public static GETEQUIPMENTSHORTLISTEDBYCOMPANYID =
      Api.base + "getEquipmentShortlistedByCompanyIdOptimize";

  public static GET_TENDOR_DETAILSBY_ID = Api.base + 'getActiveTenderDetailsbyTenderId';

  public static GETEQUIPMENTBYCOMPANYID = Api.base + "getEquipmentByCompanyId";

  public static GETEQUIPMENTREQUIREMENTBYCOMPANYID =
    Api.base + "getActiveEquipmentRequirementPostingDetailsByUserId";
    
    public static GETALLEQUIPMENTREQUIREMENT =
      Api.base + "getActiveListOfEquipmentRequirementPostingDetails";

  public static GETACTIVEPROJECTDETAILSBYCOMPANYID =
    Api.base + "getActiveProjectDetailsByCompanyId";

    public static GETACTIVEPROJECTDETAILSBYCOMPANYIDWITHOUTPAGABLE =
    Api.base + "getListOfProjectByCompanyIdWithoutPageable";

  public static SAVEEQUIPMENTSHORTLISTEDDETAIL =
    Api.base + "saveEquipmentShortlistedDetail";

  public static GETCOMPANYDASHBOARDDETAILS =
    Api.base + "getCompanyDashboardDetails";

  public static GET_ALL_EQUIPMENTS_LIST =
    Api.base + "getActiveEquipmentDetails";

  public static GET_ALL_EQUIPMENTS_REQUIREMENT_LIST =
    Api.base + "getActiveEquipmentRequirementPostingDetails";

  public static ADD_NEW_EQUIPMENTS = Api.base + "saveEquipmentDetail";

  public static PROJECT_SEARCH = Api.base + "searchProject";
  
  public static GETACTIVEPROJECTLISTFORVENDORSEARCHMODULE = Api.base + "getActiveProjectListForVendorSearchModule";       
  
  public static getListOfCompanyVendorRecommendation = Api.base + "getListOfCompanyVendorRecommendation";       

  public static GET_ZONE = Api.base + "getActiveZoneDetails";

  public static GET_EQUIPMENTS_CATEGORY =
    Api.base + "getActiveEquipmentCategoryDetails";

  public static GET_EQUIPMENTS_SUB_CATEGORY =
    Api.base + "getActiveEquipmentSubCategoryDetails";

  public static UPDATE_EQUIPMENT = Api.base + "updateEquipment";

  public static GET_SUB_CATEGORY_BY_CATEGORY_ID =
    Api.base + "getActiveEquipmentSubCategoryDetailsByEquipmentCategory";

  public static GET_OWNERSHIP_TYPE = Api.base + "getActiveOwnershipDetails";

  public static GET_AVAILABLE_FOR = Api.base + "getActiveAvailabilityDetails";

  public static SAVE_EQUIPMENT_AND_PANTS = Api.base + "saveEquipmentDetail";

  public static SAVE_EQUIPMENT_REQUIREMENTS =
    Api.base + "saveEquipmentRequirementPosting";

  public static SHORTLIST_EQUIPMENT = Api.base + "updateCompanyWithEquipment";

  public static UPDATE_EQUIPMENT_AND_PANTS = Api.base + "updateEquipment";

  public static SAVEEQUIPMENTSHORTLISTEDDETAILFORALL =
    Api.base + "saveEquipmentShortlistedDetailForAll";

  public static DELETEEQUIPMENTSHORTLISTEDFORALL =
    Api.base + "deleteEquipmentShortlistedForAll";

  public static SAVERATINGDETAIL = Api.base + "saveRatingDetail";

  public static GETACTIVEINQUIRYDETAILSBYUSERID =
    Api.base + "getActiveInquiryDetailsByUserId";

  public static SEARCH_EQUIPMENTS =
    Api.base + "getEquipmentByCategorySubCategoryZoneTypeName";

  public static SEARCH_EQUIPMENTS_CAT = Api.base + "searchEquipment";

  // public static SEARCH_SHORT_LISTED =
  //   Api.base +
  //   "getShortlistedEquipmentByCategorySubCategoryZoneTypeNameByCompany";
    
    public static SEARCH_SHORT_LISTED =
      Api.base +
      "equipmentShortlistedSearch";

  public static SEARCH_EQUIPMENTS_REQUIREMENT_POSTING =
    Api.base + "searchEquipmentRequirementPosting";

  public static GET_FEED_BACK_LIST =
    Api.base + "getActiveInquiryDetailsByUserId";
  public static CHAT_BY_ENQUIRY_ID =
    Api.base + "getActiveMessageDetailsByInquiryId";
  public static SAVE_CHAT_MESSAGE = Api.base + "saveMessageDetail";

  public static GETACTIVEA3YGROWTHDETAILS =
    Api.base + "getActiveA3YGrowthDetails";

  public static GETACTIVEASWGROWTHDETAILS =
    Api.base + "getActiveASWGrowthDetails";

  public static GETACTIVEFUNDBASEBANKLIMITDETAILS =
    Api.base + "getActiveFundBaseBankLimitDetails";

  public static GETACTIVENONFUNDBASEBANKLIMITDETAILS =
    Api.base + "getActiveNonFundBaseBankLimitDetails";

  public static GETACTIVEBANKRATINGDETAILS =
    Api.base + "getActiveBankRatingDetails";

  public static GETACTIVEDEBTEQUITYRATIODETAILSDETAILS =
    Api.base + "getActiveDebtEquityRatioDetails";

  public static GETACTIVEEBITADETAILS = Api.base + "getActiveEbitaDetails";

  public static GETACTIVEEXISTINGCOMMITMENTDETAILS =
    Api.base + "getActiveExistingCommitmentDetails";

  public static GETACTIVETERMINATIONDETAILS =
    Api.base + "getActiveTerminationDetails";

  public static GETACTIVEEARLYCOMPLETIONBONUSDETAILS =
    Api.base + "getActiveEarlyCompletionBonusDetails";

  public static GETACTIVETIMELYCOMPLETIONDETAILS =
    Api.base + "getActiveTimelyCompletionDetails";

  public static GETACTIVEESTABLISHMENTYEARDETAILS =
    Api.base + "getActiveEstablishmentYearDetails";

  public static GETACTIVEPERMANENTSTAFFDETAILS =
    Api.base + "getActivePermanentStaffDetails";

  public static GETACTIVEISODETAILS = Api.base + "getActiveIsoDetails";

  public static GETACTIVERECOGNITIONDETAILS =
    Api.base + "getActiveRecognitionDetails";

  public static GETACTIVEDISPUTEDETAILS = Api.base + "getActiveDisputesDetails";

  public static GETACTIVELEGALCASEDETAILS =
    Api.base + "getActiveLegalCaseDetails";

  // public static GET_ACTIVE_MAILS_BY_FOLDER = Api.base + 'Active';

  // public static PERMANENT_DELETE_MAIL = Api.base + 'getActiveLegalCaseDetails';

  // public static MAIL_FOLDER_TRANSFER = Api.base + 'getActiveLegalCaseDetails';

  // public static SEND_MAIL = Api.base + 'getActiveLegalCaseDetails';

  public static GET_ACTIVE_MAILS_BY_FOLDER =
    Api.base + "getMailListByPagination";

    // public static GET_ACTIVE_MAILS_BY_FOLDER =
    // Api.base + "getActiveMailDetailsByIsActive";

  public static PERMANENT_DELETE_MAIL = Api.base + "deleteMail";
  public static MAIL_FOLDER_TRANSFER = Api.base + "updateMailFolder";
  public static SEND_MAIL = Api.base + "saveMailDetail";

  public static GET_SUBSCRIPTION_ACTIVITIES_LIST =
    Api.base + "getActiveSubscriptionActivitiesDetails";
  // public static GET_SUBSCRIPTION_ACTIVITIES_LIST_BY_TYPE = Api.base + 'getActiveSubscriptionActivitiesDetailsType';  //Commented by minank

  public static DOWNLOAD_PROJECT_EXCEL_DATA = Api.base + "downloadProject";

  public static GET_PERCENTAGE_LIST =
    Api.base + "getActivePercentageRangeDetails";

  public static DOWNLOAD_PROJECT_REPORT = Api.base + "downloadProjectProposals";

  public static DOWNLOAD_PROJECT_COMPANYID =
    Api.base + "downloadProjectByCompanyId";

  public static PAYMENT = Api.base + "paymentInitiate";
  // public static GetAllBlocks = Api.base + 'getActiveBlockDetails';

  public static SAVE_RATIG_BY_COMPANY = Api.base + "saveVendorRatingDetail";

  public static GET_MAIL_COUNT = Api.base + "unreadMailCount";

  public static UPDATE_MAIL_RATING = Api.base + "updateMailCount";

  public static GET_GST_DETAILS = Api.base + "getActiveTaxDetails";

  public static EXTEND_SELLER_CONTACT_LIMIN = Api.base + "visitSubscription";
  public static GET_SECTOR_DETAILS_BY_TEAMEMBERS =
    Api.base + "getSectorDetailsByTeamMembers";

  public static GET_ACTIVE_PROJECT_DETAILS_BY_TEAMMEMBER =
    Api.base + "getActiveProjectDetailsByTeamMembersId";

  public static SAVE_PROJECT_FINANCE_DETAILS = Api.base + "saveProjectFinance";

  public static SAVE_PROJECT_INSURANCE_DETAILS =
    Api.base + "saveProjectInsurance";
    
    public static UPDATE_PROJECT_INSURANCE_DETAILS =
      Api.base + "updateProjectInsurance";
      
      public static UPDATE_PROJECT_FINANCE =
        Api.base + "updateProjectFinance";

  public static SAVE_PLANTS_EQUIPMENT_FINANCE_DETAILS =
    Api.base + "savePlantsandEquipmentFinanceDetails";
    
    public static UPDATE_PLANTS_EQUIPMENT_FINANCE_DETAILS =
      Api.base + "updatePlantsandEquipmentFinanceDetails";

  public static SAVE_PLANTS_EQUIPMENT_INSURANCE_DETAILS =
    Api.base + "savePlantsAndEquipmentInsurance";
    
    public static UPDATE_PLANTS_EQUIPMENT_INSURANCE_DETAILS =
    Api.base + "updatePlantsAndEquipmentInsurance";

    public static ANUAL_TURN_OVER = Api.base + 'getActiveAnnualTurnoverDetails';


    public static GETACTIVEPROJECTINSURANCEBYIDLIST = Api.base + 'getActiveProjectInsuranceByUserId';

    public static GETACTIVEPROJECTINSURANCEBYIDFORMOBILE = Api.base + 'getActiveProjectInsuranceByIdForMobile';
    
    public static GETACTIVEPLANTEQUIPMENTINSURANCEBYIDFORMOBILE = Api.base + 'getActivePlantsAndEquipmentInsuranceByIdForMobile';
    
    public static GETACTIVEPROJECTFINANCEBYIDFORMOBILE = Api.base + 'getActiveProjectFinanceByIdForMobile';
    
    public static GETPLANTSANDEQUIPMENTFINANCEBYIDFORMOBILE = Api.base + 'getPlantsandEquipmentFinanceDetailsByIdForMobile';
    
    public static DELETEPROJECTINSURANCEBYID = Api.base + 'deleteProjectInsuranceById';
    public static DELETEPROJECTFINANCEBYID = Api.base + 'deleteProjectFinanceById';
    public static DELETEPLANTEQUIPMENTINSURANCEBYID = Api.base + 'deletePlantsAndEquipmentInsuranceById';
    public static DELETEPLANTEQUIPMENTFINANCEBYID = Api.base + 'deletePlantsandEquipmentFinanceDetailsById';

    public static GETACTIVEPLANTEQUIPMENTINSURANCEBYIDLIST = Api.base + 'getActivePlantsAndEquipmentInsuranceByUserId';

    public static GETACTIVEPROJECTFINANCEBYIDLIST = Api.base + 'getActiveProjectFinanceByUserId';

    public static GETACTIVEPLANTEQUIPMENTFINANCEIDLIST = Api.base + 'getPlantsandEquipmentFinanceDetailsByUserId';

    public static SEARCHPLANTSEQUIPMENTSINSURANCE = Api.base + 'searchPlantsAndEquipmentInsurance';

    public static SEARCHPLANTSEQUIPMENTSFINANCE = Api.base + 'searchPlantsAndEquipmentFinance';

    public static SEARCHPROJECTINSURANCE = Api.base + 'searchProjectInsurance';

    public static SEARCHPROJECTFINANCE = Api.base + 'searchProjectFinance';

    public static GETACTIVEPROJECTINSURANCEdETAILS = Api.base + 'getActiveProjectInsuranceById';

    public static GETACTIVEPLANTSANDEQUIPMENTDETAILS = Api.base + 'getActivePlantsAndEquipmentInsuranceById';

    public static GETACTIVEPROJECTFINANCEDETAILS = Api.base + 'getActiveProjectFinanceById';

    public static GETACTIVEPROJECTPLANTSANDEQUIPMENTEDETAILSBYID = Api.base + 'getPlantsandEquipmentFinanceDetailsById';

    public static AddWorkTypeToCompany = Api.base + 'addWorkTypeToCompany';
    
    public static AddWorkTypeToVendor = Api.base + 'addWorkTypeToVendor';

    public static GETACTIVELISTOFWORKTYPEDETAILSBYCOMPANYIDWITHPAGEABLE =
    Api.base + "getActiveListOfWorkTypeDetailsByCompanyIdWithPageable";

    public static DELETEWORKTYPEOFCOMPANY = Api.base + 'deleteWorkTypeOfCompany';

    public static DELETEWORKTYPEOFVENDOR = Api.base + 'deleteWorkTypeOfVendor';

    public static DELETEALLWORKTYPEOFCOMPANY = Api.base + 'deleteAllWorkTypeOfCompany';

    public static DELETEALLWORKTYPEOFVENDOR = Api.base + 'deleteAllWorkTypeOfVendor';

    public static GETACTIVELISTOFWORKTYPEDETAILSBYVENDORIDWITHPAGEABLE =
        Api.base + "getActiveListOfWorkTypeDetailsByVendorIdWithPageable";
}
